import React, { Fragment, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DealsCard from "../components/cards/DealsCard";
import DealsCardMobile from "../components/cards/DealsCardMobile";
import { server } from "../config";
import { Navigation, Pagination, Autoplay, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import Head from "next/head";
import Skeleton from "@mui/material/Skeleton";
import { nanoid } from "nanoid";
import darkTheme from '../src/theme';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InfiniteScroll from "react-infinite-scroll-component";
import { isMobile } from "react-device-detect";
    
const dealsContainerAll = {
  marginTop: darkTheme.spacing(2.5),
  marginBottom: darkTheme.spacing(2.5),
  [darkTheme.breakpoints.down("sm")]: {
    marginTop: darkTheme.spacing(7),
  },
  '& h1': {
    fontSize: 60,
    fontWeight: 500,
    marginTop: darkTheme.spacing(3),        
  },
  '& h2': {
    fontSize: 30,
    fontWeight: 400,
    marginTop: darkTheme.spacing(5),        
    [darkTheme.breakpoints.down("md")]: {
      paddingBottom: darkTheme.spacing(2),
      marginBottom: darkTheme.spacing(0.5),
      marginTop: darkTheme.spacing(3),
      fontSize: 25,
    }
  },
  '& h3': {
    fontSize: 16,
    fontWeight: 400,
    color: darkTheme.palette.primary.subTitle,
    marginTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),    
  }
};

const areaNameStyleSelected = {
  color: `${darkTheme.palette.background.default} !important`,
  backgroundColor: `${darkTheme.palette.primary.main} !important`,
  textTransform: 'capitalize',
  fontWeight: 100,
  cursor: 'pointer',
  fontSize: 12,
  border: `1px solid ${darkTheme.palette.primary.main}`,
  borderRadius: 15,
  padding: `4px 8px`,
  [darkTheme.breakpoints.down("md")]: {        
    fontSize: 12,
  }
}

const areaNameStyle = {
  color: '#C3C3C3',
  textTransform: 'capitalize',
  fontWeight: 100,
  cursor: 'pointer',
  fontSize: 12,
  border: `1px solid #5D5D5D`,
  borderRadius: 15,
  padding: `4px 8px`,
  [darkTheme.breakpoints.down("md")]: {        
    fontSize: 12,
  }
}


export const getStaticProps = async function (context) {
  try {

    let banners = ""
    // const date = moment(new Date()).format("YYYY-MM-DD");
  
    const res = await axios.get(`${server}/api/banners/deals`, {
      headers: {
        "x-auth-token": process.env.JWT_TOKEN,
      },
    });
  
    banners = res.data.result ? res.data.result : [];    
    const res1 = await axios.get(
      `${server}/api/global/deals?start=0&limit=12&page=dealsAll`,
      {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      }
    );
  
    const dealsList = res1.data.result ? res1.data.result : [];
  
    return {
      props: { banners, dealsList },
      revalidate: 1
    };
  } catch (e) {
    console.log(e)
    // return {notFound: true}
  }
};

function Deals(props) {  

  const [dataLimit, setDataLimit] = useState(10);
  const [dealsListDynamic, setDealsListDynamic] = useState(props.dealsList.length > 0 ? props.dealsList.slice(0, dataLimit) : props.dealsList)
  const [dealsList, setDealsList] = useState(props.dealsList);
  const [dealsListAll, setDealsListAll] = useState(props.dealsList);
  const [areaNames, setAreaNames] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(props.dealsList ? false : true);
  const [selectedArea, setSelectedArea] = useState('');
  const [moreLoading, setMoreLoading] = useState(true)

  function getSearchItems(event) {
    const keyword = event.target.value;
    setSearchKey(keyword);
    setSelectedArea(''); 
    // setHasMore(false);
    axios
      // .get(`${server}/api/global/allDeals?keyword=${keyword}`, {
      .get(`/api/global/allDeals?keyword=${keyword}`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          const newPosts = res.data;
          setDealsList(newPosts.result);
          setDealsListDynamic(newPosts.result);
          setLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
      })
  } 

  useEffect(() => {
    const res1 = Object.values(dealsListAll.reduce((a, { area_name }) => {
      a[area_name] = { area_name }
      return a;
    }, {}))    
    setAreaNames(res1);
    areaNames.sort();    
  }, [dealsListAll]);
  
  const getAreaDealsHandler = async(area) => { 
    
    let res1 = await dealsListAll.filter((item) => {
      return item.area_name == area
    });
    setSelectedArea(area)
    setDealsList(res1);
    setDealsListDynamic(res1);
  }
  
  let skeletonCards = Array(8).fill(0);
  let skeletonCards2 = Array(1).fill(0); 

  const fetchMoreData = () => {
    setTimeout(() => {
      const newLimit = dataLimit + 12
      const newData = dealsList.slice(0, newLimit)
      setDealsListDynamic(newData)
      setDataLimit(newLimit)

      if (dealsList.length === newData.length) {
        setMoreLoading(false);
      }
    }, 500);
  }

  return (
    <Fragment>
      <Head>
        <title>{`Discover discounts from Best Pubs, Nightclubs and Live Music venues - Clubr`}</title>
        <meta name="description" content={`Discover discounts and deals like Happy Hours, MRP Nights and pub Lunch deals from the best Pubs, Nightclubs and nightlife venues and book online deals directly from Clubr.`}></meta>
        <meta property="og:title" content={`Discover discounts from Best Pubs, Nightclubs and Live Music venues - Clubr`}></meta>
        <meta property="og:description" content={`Discover discounts and deals like Happy Hours, MRP Nights and pub Lunch deals from the best Pubs, Nightclubs and nightlife venues and book online deals directly from Clubr.`}></meta>
        <meta property="og:image" content={props.banners ? props.banners[0].img_path : ''}></meta>
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clubr" />
        <meta property="og:url" content={`https://clubr.in/deals`} />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:site" content="@Clubr14"></meta>
        <meta name="twitter:creator" content="@Clubr14"></meta>
        <meta name="twitter:title" content={`Discover discounts from Best Pubs, Nightclubs and Live Music venues - Clubr`}></meta>
        <meta name="twitter:description" content={`Discover discounts and deals like Happy Hours, MRP Nights and pub Lunch deals from the best Pubs, Nightclubs and nightlife venues and book online deals directly from Clubr.`}></meta>
        {/* <meta name="twitter:image" content={props.banners ? props.banners[0].img_path : ''}></meta> */}
      </Head>
    
      <div className={"main_sec"}>                
        <Typography component="div" sx={dealsContainerAll}>        
            <Grid container spacing={3}>
              <Grid item xl={8} lg={ 8} md={8} sm={12} xs={12} className="desktopMode" alignSelf="center">
                <Typography variant="h1">Grab the Deals</Typography>                    
                <Typography variant="h3">Discover discounts & deals from the best pubs, Nightclubs and Live Music Venues</Typography>
            </Grid>
            {dealsList.length > 0 && (
              <Grid item xl={4} lg={4} md={4} sm={12} xs={12} alignSelf="center">
                <Box className="searchBox" sx={{ height: { md: '50px',sm:'40px'}}}>
                  <Typography component="span" sx={{mt:1, pl:2}}><SearchIcon /></Typography>
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search Here"
                    inputProps={{ 'aria-label': 'Search Here' }}
                    onChange={getSearchItems}
                  />
                </Box>
              </Grid>
            )}
          </Grid>   
          {!searchKey && dealsList.length > 0 && areaNames.length > 1 && (
            <Typography component="div" sx={{width : '100%', mt:3}}>                        
              <Grid container spacing={1}>
                <Grid item xs={2.5} sm={1.5} md={1} lg={1} xl={1}><Typography component="p" sx={{color:'#C0C0C0', fontSize:{md:16, sm:14, xs:12}}}>Locations:&nbsp;&nbsp;</Typography></Grid>
                <Grid item xs={9.5} sm={10.5} md={11} lg={11} xl={11}>
                  <Swiper
                    className="autoWidthSlider"
                    modules={[Navigation, Pagination]}
                    spaceBetween={10}
                    navigation={false}
                    autoplay={false}
                    loop={false}
                    slidesPerView="auto"                    
                    >
                {areaNames.map(item => {
                  return (
                    <SwiperSlide key={nanoid(2)}>
                      {item.area_name && (
                        <>
                          {selectedArea == item.area_name.trim() ? (
                            <Typography component="p" onClick={() => getAreaDealsHandler(item.area_name)} key={nanoid(30)} sx={areaNameStyleSelected}>
                              {item.area_name}
                            </Typography>
                            ) : (                                                              
                              <Typography component="p" onClick={() => getAreaDealsHandler(item.area_name)} key={nanoid(30)} sx={areaNameStyle}>
                                {item.area_name}
                              </Typography>                                
                          )}
                        </>
                      )}
                  </SwiperSlide>
                  )
                })} 
                  </Swiper>
                </Grid>
              </Grid>              
            </Typography>  
          )}
          
          {dealsList.length > 0 && (<Typography variant="h2" sx={{ mb: 3}}>Deals & Happy Hours</Typography>)}                                  
              <Typography component="div">
                {dealsList.length > 0 && (
                  <>
                    {loading ? (
                      <Typography component="div" sx={{ pb: 5 }}>
                        <Grid container spacing={5}>
                          {skeletonCards.map((index) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={8}
                              lg={8}
                              xl={8}
                              key={nanoid(30)}
                            >
                              <Skeleton
                                variant="rectangular"
                                height={200}
                                sx={{ borderRadius: "20px" }}
                                key={"sk" + index}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Typography>
                ) : (
                  <InfiniteScroll
                    scrollThreshold={0.6}
                    style={{ overflow: "hidden" }}
                    dataLength={dealsListDynamic.length}
                    next={fetchMoreData}
                    hasMore={true}
                    loader={<></>}
                    endMessage={<></>}
                  >
                    <>
                      <div className="desktopMode">
                      <Grid container spacing={4}>
                        {dealsListDynamic.map((deal, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            key={nanoid(30)}
                            className="dealsPage"
                          >
                            <DealsCard data={deal} />
                          </Grid>
                        ))}
                      </Grid>
                      </div>

                      <div className="mobileMode">
                      <Grid container spacing={4}>
                        {dealsListDynamic.map((deal, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            key={nanoid(30)}
                            className="dealsPage"
                          >
                            <DealsCardMobile data={deal} />
                          </Grid>
                        ))}
                      </Grid>
                      </div>
                    </>
                  </InfiniteScroll>
                    )}
                  </>
                )}
              </Typography>

          {
            moreLoading ? (
              <Typography component="div" sx={{ py: 5 }}>
                        <Grid container spacing={5}>
                          {skeletonCards2.map((index) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={8}
                              lg={8}
                              xl={8}
                              key={nanoid(30)}
                            >
                              <Skeleton
                                variant="rectangular"
                                height={200}
                                sx={{ borderRadius: "20px" }}
                                key={"sk" + index}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Typography>
            ) : (
              <Typography component="div" sx={{ textAlign: 'center', my: 7 }}> 
              <Stack display="flex" alignItems="center" flexDirection="row" justifyContent="center">  
                <img src="../images/deals-end.png" alt="" style={{ 'width': 30 }} />&nbsp;
                <Typography component="span" style={{ "fontSize":16, fontWeight:100, color: '#979797'  }}>End of Search results for Deals & Happy Hours</Typography>
              </Stack>
              </Typography>
            )
          } 
        </Typography>  
      </div>
    </Fragment>
  );
}

export default Deals;
